// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1351":"e60b7166","8594":"e60b7166"}[chunkId] + ".chunk.css";
};